var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlumniAssociation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0145 24.7834C6.93657 24.7834 4.43237 22.2334 4.43237 19.099C4.43237 15.9639 6.93657 13.4138 10.0145 13.4138C13.0924 13.4138 15.5962 15.9639 15.5962 19.099C15.5962 22.2334 13.0924 24.7834 10.0145 24.7834ZM10.0145 15.8796C8.27161 15.8796 6.85343 17.3235 6.85343 19.099C6.85343 20.8737 8.27161 22.3177 10.0145 22.3177C11.7574 22.3177 13.1752 20.8737 13.1752 19.099C13.1752 17.3235 11.7574 15.8796 10.0145 15.8796Z",
    fill: "url(#paint0_linear_87_6218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6066 40.126H2.02489C1.36683 40.126 0.829337 39.5906 0.814762 38.9204L0.734375 35.2218C0.73398 29.9829 4.89713 25.7424 10.0147 25.7424C13.1545 25.7424 16.0614 27.3453 17.7897 30.031C18.1562 30.6001 18.0001 31.3642 17.441 31.7383C16.8822 32.1115 16.1319 31.9526 15.7651 31.3827C14.4856 29.3953 12.3356 28.2082 10.0147 28.2082C6.23218 28.2082 3.15503 31.3426 3.15503 35.1945L3.20901 37.6602H14.6066C15.2753 37.6602 15.8171 38.2125 15.8171 38.8931C15.8171 39.5738 15.2753 40.126 14.6066 40.126Z",
    fill: "url(#paint1_linear_87_6218)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3731 24.7834C34.2952 24.7834 31.791 22.2334 31.791 19.099C31.791 15.9639 34.2952 13.4138 37.3731 13.4138C40.4511 13.4138 42.9549 15.9639 42.9549 19.099C42.9549 22.2334 40.4511 24.7834 37.3731 24.7834ZM37.3731 15.8796C35.6303 15.8796 34.2121 17.3235 34.2121 19.099C34.2121 20.8737 35.6303 22.3177 37.3731 22.3177C39.116 22.3177 40.5338 20.8737 40.5338 19.099C40.5338 17.3235 39.116 15.8796 37.3731 15.8796Z",
    fill: "url(#paint2_linear_87_6218)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5239 40.126H32.7811C32.1124 40.126 31.5705 39.5738 31.5705 38.8931C31.5705 38.2125 32.1124 37.6602 32.7811 37.6602H44.2862L44.2334 35.2218C44.233 31.3425 41.1558 28.2082 37.3733 28.2082C35.052 28.2082 32.902 29.3953 31.6226 31.3827C31.2553 31.9526 30.505 32.1115 29.9466 31.7383C29.3875 31.3642 29.2314 30.6001 29.5979 30.031C31.3262 27.3453 34.2331 25.7424 37.3733 25.7424C42.4909 25.7424 46.654 29.9829 46.654 35.1945L46.734 38.8658C46.7415 39.1973 46.617 39.5184 46.3892 39.7552C46.1615 39.9919 45.8498 40.126 45.5239 40.126Z",
    fill: "url(#paint3_linear_87_6218)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6939 28.0274C27.2596 28.0274 30.1501 25.0835 30.1501 21.4521C30.1501 17.8206 27.2596 14.8767 23.6939 14.8767C20.1283 14.8767 17.2378 17.8206 17.2378 21.4521C17.2378 25.0835 20.1283 28.0274 23.6939 28.0274Z",
    fill: "url(#paint4_linear_87_6218)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5241 3.19137L23.973 0.035252C23.8176 -0.0117507 23.6512 -0.0117507 23.4958 0.035252L12.9446 3.19137C12.6038 3.29308 12.3716 3.59898 12.3716 3.94534C12.3716 4.29169 12.6038 4.5976 12.9446 4.69931L17.1369 5.95331L16.4456 9.31366C16.3675 9.69315 16.5839 10.0715 16.9564 10.2075L23.4494 12.5746C23.5414 12.6081 23.6377 12.6247 23.7344 12.6247C23.8311 12.6247 23.9274 12.6081 24.0193 12.5746L30.5128 10.2075C30.8853 10.0715 31.1017 9.69315 31.0232 9.31366L30.3319 5.95331L33.4739 5.01345V11.0466C33.4739 11.4823 33.837 11.8356 34.2856 11.8356C34.7342 11.8356 35.0972 11.4823 35.0972 11.0466V3.94534C35.0972 3.59898 34.865 3.29308 34.5241 3.19137ZM23.7344 1.61485L28.8878 3.15631H23.7344C23.2862 3.15631 22.9228 3.5096 22.9228 3.94534C22.9228 4.38108 23.2862 4.73437 23.7344 4.73437H28.8878L23.7344 6.27582L15.9431 3.94534L23.7344 1.61485ZM29.2961 8.96538L23.7344 10.993L18.1727 8.96538L18.6962 6.41977L23.4958 7.85542C23.5735 7.87892 23.6539 7.89048 23.7344 7.89048C23.8148 7.89048 23.8953 7.87892 23.973 7.85542L28.7725 6.41977L29.2961 8.96538Z",
    fill: "url(#paint5_linear_87_6218)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6943 29.6711C17.687 29.6711 12.7996 34.6484 12.7996 40.767C12.7996 41.4477 13.3414 41.9999 14.0101 41.9999H33.3785C34.0472 41.9999 34.589 41.4477 34.589 40.767C34.589 34.6484 29.7016 29.6711 23.6943 29.6711Z",
    fill: "url(#paint6_linear_87_6218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_6218",
    x1: 9.71586,
    y1: 1.01364,
    x2: 17.1524,
    y2: 19.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_6218",
    x1: 8.89992,
    y1: 10.0551,
    x2: 16.9641,
    y2: 34.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_6218",
    x1: 37.0745,
    y1: 1.01364,
    x2: 44.511,
    y2: 19.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_6218",
    x1: 37.6036,
    y1: 10.0551,
    x2: 45.6373,
    y2: 34.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_6218",
    x1: 23.3487,
    y1: 0.534002,
    x2: 31.9504,
    y2: 22.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_87_6218",
    x1: 23.1269,
    y1: -13.769,
    x2: 28.1088,
    y2: 9.20169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_87_6218",
    x1: 23.1118,
    y1: 16.2249,
    x2: 28.0587,
    y2: 38.6196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumniAssociation);
export default __webpack_public_path__ + "static/media/Alumni Association.6ec2748083cafb0c96f6fdee58117f6c.svg";
export { ForwardRef as ReactComponent };